<template>
  <div class="table-responsive">
    <table class="table table-hover table-bordered bg-white table-striped">
      <thead>
        <th v-if="debt.deleted_at === null">{{ $t('app.action') }}</th>
        <th>{{ $t('app.type') }}</th>
        <th>{{ $t('phones.phone') }}</th>
        <th>{{ $t('phones.owner') }}</th>
        <th>{{ $t('phones.created_at') }}</th>
        <th>{{ $t('phones.last_contact') }}</th>
      </thead>
      <tbody>
        <template v-if="!loadPhones">
          <tr v-for="(phone, index) in phones" :key="phone.id">
            <td v-if="debt.deleted_at === null">
              <button @click.prevent="initAddCall(index)" class="btn btn-primary btn-sm min-width-125">
                {{ $t('calls.add') }}
              </button>
            </td>
            <td>{{phone.type ? phone.type.name : ''}}</td>
            <td>
              {{phone.phone}}
              <a :href="`tel:${phone.phone}`">
                <img src="/assets/media/icons/zoiper.png" width="30">
              </a>
            </td>
            <td>
              <span v-if="phone.contact_face">{{phone.contact_face.fullname || ''}}</span><br v-if="phone.contact_face">
              <span class="badge badge-pill" :class="{'badge-success': phone.contact_face, 'badge-info': phone.debtor}">{{phone.who}}</span>
            </td>
            <td>{{phone.created_at | datetimeFormat}}</td>
            <td>{{phone.last_contact | datetimeFormat}}</td>
          </tr>
        </template>
        <tr v-if="loadPhones">
          <td colspan="5" class="text-center">
            <div class='sk-wave'>
              <div class='sk-rect sk-rect-1'></div>
              <div class='sk-rect sk-rect-2'></div>
              <div class='sk-rect sk-rect-3'></div>
              <div class='sk-rect sk-rect-4'></div>
              <div class='sk-rect sk-rect-5'></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      phone: {
        debtor: {},
        contact_face: {},
      },
      errors: {},
      isProcessing: false,
      loadPhones: false,
    };
  },
  computed: {
    ...mapGetters([
      'phones',
      'debt',
    ]),
  },
  mounted() {
    if (this.debt.debtor_iin) {
      this.GET_PHONES(this.debt.debtor_iin);
    }
  },
  methods: {
    ...mapActions([
      'GET_PHONES',
      'INIT_PHONE',
    ]),
    initAddCall(index) {
      $('#add-call').modal('show');
      this.phone = this.phones[index];
      if (this.phones[index].debtor) {
        this.phone.debtor = this.phones[index].debtor;
      }
      if (this.phones[index].contact_face) {
        this.phone.contact_face = this.phones[index].contact_face;
      }
      this.INIT_PHONE(this.phone);
    },
  },
};
</script>
